import React from 'react'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import PersonIcon from '@material-ui/icons/Person'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import EnhancedAnalyticsCard from './EnhancedAnalyticsCard'

/**
 * Consolidated earnings card component for coach analytics
 */
export const EarningsCard = ({ data, loading, error }) => {
  return (
    <EnhancedAnalyticsCard
      value={data?.total || 0}
      label={data?.source || 'Earnings'}
      icon={<AttachMoneyIcon />}
      iconColor="#00205B"
      valueColor="#00205B"
      loading={loading}
      error={error}
      useCountUp={true}
      prefix="$"
      tooltip="Total earnings through PGA Coach platform"
    />
  )
}

/**
 * Consolidated private lesson revenue card component
 */
export const PrivateLessonRevenueCard = ({ data, loading, error }) => {
  // Use demo revenue if no data is available
  const revenueAmount = data?.revenue || 0

  return (
    <EnhancedAnalyticsCard
      value={revenueAmount}
      label="Total Private Lesson Revenue"
      icon={<AttachMoneyIcon />}
      iconColor="#00205B"
      valueColor="#00205B"
      labelColor="#4dabf5"
      loading={loading}
      error={error}
      useCountUp={true}
      prefix="$"
      tooltip="Revenue from individual private lessons"
    />
  )
}

/**
 * Consolidated group event revenue card component
 */
export const GroupEventRevenueCard = ({ data, loading, error }) => {
  // Use demo revenue if no data is available
  const revenueAmount = data?.revenue || 0

  return (
    <EnhancedAnalyticsCard
      value={revenueAmount}
      label="Total Group Event Revenue"
      icon={<AttachMoneyIcon />}
      iconColor="#00205B"
      valueColor="#00205B"
      labelColor="#3f51b5"
      loading={loading}
      error={error}
      useCountUp={true}
      prefix="$"
      tooltip="Revenue from group events and clinics"
    />
  )
}

/**
 * Consolidated lead card component
 */
export const LeadCard = ({ title, value, loading, error }) => {
  return (
    <EnhancedAnalyticsCard
      value={value || 0}
      label={title}
      icon={<PersonIcon />}
      iconColor="#00205B"
      loading={loading}
      error={error}
    />
  )
}

/**
 * Consolidated stat card component
 */
export const StatCard = ({ title, value, subtitle, loading, error }) => {
  return (
    <EnhancedAnalyticsCard
      value={value || 0}
      label={title}
      tooltip={subtitle}
      loading={loading}
      error={error}
    />
  )
}

/**
 * Consolidated conversion rate card component
 */
export const ConversionRateCard = ({ value, loading, error }) => {
  return (
    <EnhancedAnalyticsCard
      value={value || '0%'}
      label="Conversion Rate"
      icon={<TrendingUpIcon />}
      iconColor="#4caf50"
      tooltip="Percentage of leads that convert to customers"
      loading={loading}
      error={error}
    />
  )
}
